import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/unauthenticated/pages/login/login.component';
import { AuthenticatedComponent } from './pages/authenticated/authenticated.component';
import { SigninCallbackComponent } from './pages/unauthenticated/pages/signin-callback/signin-callback.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { PermissionGuard } from './shared/guards/permission.guard';
import { NotFoundComponent } from './pages/unauthenticated/pages/not-found/not-found.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'signin-callback',
    component: SigninCallbackComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'shipping',
    loadChildren: () =>
      import('./pages/unauthenticated/pages/customer-shipping-tool/customer-shipping-tool.module').then(
        (m) => m.CustomerShippingToolModule
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [PermissionGuard],
    component: AuthenticatedComponent,
    loadChildren: () => import('./pages/authenticated/authenticated.module').then((m) => m.AuthenticatedModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
